import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  mainBox: {
    width: "100%",
    padding: theme.spacingRules.cardPaddingDesktop,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    backgroundColor: "transparent",
    [theme.breakpoints.down("sm")]: {
      padding: theme.spacingRules.cardPaddingMobile,
    },
  },

  sectionTitle: {
    fontSize: "1.8rem !important",
    fontWeight: "900 !important",
    color: `${theme.agentTheme.background.primary_text} !important`,
    textAlign: "center !important",
    marginBottom: "50px !important",
    [theme.breakpoints.down("sm")]: {
      fontSize: "28px !important",
      marginBottom: "30px !important",
    },
  },

  articlesContainer: {
    display: "flex",
    gap: "30px",
    maxWidth: "1216px",
    width: "100%",
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
      gap: "20px",
    },
  },

  articleWrapper: {
    flex: 1,
    minHeight: "400px",
    [theme.breakpoints.down("sm")]: {
      minHeight: "300px",
    },
  },

  articleCard: {
    width: "100%",
    height: "100%",
    // borderRadius: "12px",
    overflow: "hidden",
    position: "relative",
    cursor: "pointer",
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    transition: "transform 0.3s ease, box-shadow 0.3s ease",
    "&:hover": {
      transform: "translateY(-5px)",
      "& $articleContentDefault": {
        opacity: 0,
      },
      "& $articleContentHover": {
        opacity: 1,
      },
    },
  },
  articleImage: {
    transition: "transform 0.5s ease", // smooth zoom
    "&:hover": {
      transform: "scale(1.1)", // zoom on hover
    },
  },

  articleCardMob: {
    width: "100%",
    height: "100%",
    overflow: "hidden",
    position: "relative",
    cursor: "pointer",
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    transition: "transform 0.3s ease, box-shadow 0.3s ease",
    "&:hover": {
      transform: "translateY(-5px)",
      "& $articleContentDefault": {
        opacity: 0,
      },
      "& $articleContentHover": {
        opacity: 1,
      },
    },
  },

  articleContentDefault: {
    position: "absolute",
    bottom: 0,
    left: 0,
    right: 0,
    padding: "30px",
    color: theme.agentTheme.card.foreground,
    opacity: 1,
    transition: "opacity 0.3s ease",
    [theme.breakpoints.down("sm")]: {
      padding: "25px 20px",
    },
  },
  articleContentHover: {
    position: "absolute",
    bottom: 0,
    left: 0,
    right: 0,
    top: 0,
    padding: "30px",
    background: `linear-gradient(transparent, ${theme.agentTheme.primary.main}66)`,
    color: theme.agentTheme.primary.foreground,
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-end",
    gap: "15px",
    opacity: 0,
    transition: "opacity 0.3s ease",
    [theme.breakpoints.down("sm")]: {
      padding: "25px 20px",
      gap: "12px",
    },
  },

  articleTitle: {
    fontSize: "20px !important",
    fontWeight: "600 !important",
    color: `${theme?.agentTheme?.card?.foreground} !important`,
    lineHeight: "1.8 !important",
  },

  articleTitleHover: {
    fontSize: "24px !important",
    fontWeight: "700 !important",
    color: `${theme.agentTheme.card.foreground} !important`,
    lineHeight: "1.3 !important",
    // textShadow: "0 2px 4px rgba(0, 0, 0, 0.7)",
    [theme.breakpoints.down("sm")]: {
      fontSize: "20px !important",
    },
  },
  articleSummary: {
    fontSize: "14px",
    fontWeight: 500,
    marginTop: "1rem",
    lineHeight: 1.5,
  },

  maxWidth: {
    maxWidth: "1140px",
  },

  headingText: {
    fontSize: "28px !important",
    fontWeight: "600 !important",
    color: theme.agentTheme.background.primary_text,
  },
  readMoreButton: {
    backgroundColor: `${theme.agentTheme.primary.main} !important`,
    marginTop: "0.5rem",
    color: `${theme.agentTheme.primary.foreground} !important`,
    padding: "10px 20px !important",
    fontSize: "14px !important",
    fontWeight: "900 !important",
    textTransform: "uppercase !important",
    letterSpacing: "1px !important",
    alignSelf: "flex-start !important",
    transition: "all 0.3s ease !important",
    "&:hover": {
      backgroundColor: `${theme.agentTheme.primary.main} !important`,
      transform: "translateY(-2px)",
    },
    [theme.breakpoints.down("sm")]: {
      padding: "8px 16px !important",
      fontSize: "11px !important",
    },
  },

  paginationContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    marginTop: "40px",
    gap: "10px",
  },

  paginationDot: {
    width: "6px",
    height: "6px",
    borderRadius: "50%",
    backgroundColor: `${theme.agentTheme.primary.foreground}`,
    cursor: "pointer",
    transition: "all 0.3s ease",
    "&:hover": {
      backgroundColor: `${theme.agentTheme.primary.foreground} !important`,
      transform: "scale(1.2)",
    },
  },

  paginationDotActive: {
    backgroundColor: `${theme.agentTheme.primary.main} !important`,
    transform: "scale(1.3)",
  },
}));

export default useStyles;
